import MastercardSVG from '@/assets/svg/payment/provider/Mastercard.svg'
import PaypalSVG from '@/assets/svg/payment/provider/Paypal.svg'
import ApplePaySVG from '@/assets/svg/payment/provider/ApplePay.svg'
import StripeSVG from '@/assets/svg/payment/provider/Stripe.svg'
import VisaSVG from '@/assets/svg/payment/provider/Visa.svg'

export const PAYMENT_METHODS = [
  {
    icon: MastercardSVG,
    key: 'mastercard',
  },
  {
    icon: PaypalSVG,
    key: 'paypal',
  },
  {
    icon: ApplePaySVG,
    key: 'applepay',
  },
  {
    icon: StripeSVG,
    key: 'stripe',
  },
  {
    icon: VisaSVG,
    key: 'visa',
  },
]
